import createVueApp from '@phoenix/createVueApp';
import { PhxsgPageSlider, PhxsgPageSliderSlide } from '@sg/src/View/Components/Organisms/PageSlider';

document.querySelectorAll('.phoenix-page-slider').forEach((el) => {
  const app = createVueApp({});
  app.component('PhxsgPageSlider', PhxsgPageSlider);
  app.component('PhxsgPageSliderSlide', PhxsgPageSliderSlide);
  app.mount(el);
});
